(function () {
	'use strict';

	angular
		.module('app.myWork')
		.controller('strategicSourcing', strategicSourcing);

	strategicSourcing.$inject = ['$scope', '$state', '$timeout', 'pageTimingService', 'storeService'];

	function strategicSourcing($scope, $state, $timeout, pageTimingService, storeService) {
		var vm = this;
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		globalReportName = 'strategic-sourcing';
		vm.useReactReport = true;
		vm.reportName = 'Strategic sourcing';
		vm.isSavedReport = false;
		vm.showSaveReport = !reportSettingsId;

		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {
				vm.reportName = reportSettings.reportName;
			}
		});
	}
})();
